export type LanguageCode = 'nl';

type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};
const languages: Language[] = [
	{
		code: 'nl',
		file: 'nl.ts',
	},
];

export default languages;
